export const actionTypes = {
  TOAST_ERROR: 'TOAST_ERROR',
  TOAST_INFO: 'TOAST_INFO',
  TOAST_REMOVE: 'TOAST_REMOVE',
  TOAST_SUCCESS: 'TOAST_SUCCESS',
  TOAST_WARNING: 'TOAST_WARNING',
};

export const actionCreators = {
  error: (message: string) => ({
    type: actionTypes.TOAST_ERROR,
    payload: { message },
  }),
  info: (message: string) => ({
    type: actionTypes.TOAST_INFO,
    payload: { message },
  }),
  remove: () => ({
    type: actionTypes.TOAST_REMOVE,
  }),
  success: (message: string) => ({
    type: actionTypes.TOAST_SUCCESS,
    payload: { message },
  }),
  warning: (message: string) => ({
    type: actionTypes.TOAST_WARNING,
    payload: { message },
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
